import React, { Component } from 'react'
import { Fade } from 'react-awesome-reveal'
import WaterWave from 'react-water-wave'

class Banner extends Component {
  render() {
    let lanaData = this.props.lanaData
    let { bClass, textLeft, imag } = this.props
    return (
      <section id="home">
        <WaterWave
          strength={500}
          className={`banner_area ${bClass}`}
          style={{ width: '100%', height: '100%', backgroundSize: 'cover' }}
          imageUrl={require('../../image/' + imag)}
        >
          {({ getRootProps }) => (
            <div className="container">
              <div className={`banner_content ${textLeft}`}>
                <Fade direction="up">
                  <h5>BIENVENUE</h5>
                </Fade>
                <Fade direction="up" duration={1500}>
                  <h2 className="wow fadeInLeft animated">
                    Association {lanaData.name}
                  </h2>
                </Fade>
                <Fade direction="up" duration={2200}>
                  <h4 className="wow fadeInUp anoimated">
                    L'Humain, le Développement communautaire et l'Environnement
                    sont au coeur de nos pré-occupations.
                  </h4>
                </Fade>
                <ul className="list_style social_icon">
                  {lanaData.socialLinks &&
                    lanaData.socialLinks.map((item) => {
                      return (
                        <li key={item.name}>
                          <a href={item.url}>
                            <i className={item.className}></i>
                          </a>
                        </li>
                      )
                    })}
                </ul>
              </div>
            </div>
          )}
        </WaterWave>
      </section>
    )
  }
}

export default Banner
